var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "view" }, [
    _c(
      "div",
      { staticClass: "view__main" },
      [
        _c(
          "Tabs",
          {
            staticClass: "view__main__tabs",
            attrs: { value: _vm.activeTab },
            on: { input: (val) => (_vm.activeTab = val) },
          },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "Tab",
              {
                key: tab.key,
                staticClass: "view__main__tab",
                class: {
                  "view__main__tab--active": _vm.activeTab.key == tab.key,
                },
                attrs: { tab: tab },
              },
              [_vm._v("\n        " + _vm._s(tab.name) + "\n      ")]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "view__columns" }, [
          _vm.activeTab.name === "Основное"
            ? _c(
                "div",
                { staticClass: "view__column view__column--1" },
                [
                  _c("div", { staticClass: "view__column-title" }, [
                    _vm._v("Общая информация"),
                  ]),
                  _vm._v(" "),
                  _c("ProfileBlock", { staticClass: "view__profile-block" }),
                  _vm._v(" "),
                  _c("GeneralInfoBlock"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTab.name === "Пароль"
            ? _c(
                "div",
                { staticClass: "view__column view__column--2" },
                [
                  _c("div", { staticClass: "view__column-title" }, [
                    _vm._v("Изменить пароль"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "view__column-subtitle" }, [
                    _vm._v(
                      "\n          Пароль должен содержать цифры, прописные и строчные буквы и состоять хотя бы из 7 символов\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("PasswordForm"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTab.name === "Уведомления"
            ? _c(
                "div",
                { staticClass: "view__column view__column--3" },
                [
                  _c("NotificationsBlock", { ref: "notificationsBlock" }),
                  _vm._v(" "),
                  _c("NotificationChannels", {
                    ref: "notificationChannels",
                    class: { row: _vm.isWrapped },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }